import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NavService } from "../../../shared/service/nav.service";
import { KeycloakService } from "keycloak-angular";
import { UserService } from "../../onboarding/services/user.service";
import { environment } from "../../../../environments/environment";
import { Router } from '@angular/router';
import { DocumentService } from 'src/app/shared/service/document.service';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss']
})
export class PublicHeaderComponent implements OnInit {
  public rightSidebar: boolean = false;
  public open: boolean = false;
  public openNav: boolean = false;
  public isOpenMobile: boolean;
  public home: string = "Acasă";
  public about: string = "Despre POSF";
  public manual: string = "Manuale POSF";
  public contact: string = "Contact";
  public comparators: string = "Comparatoare";
  public offerComparisonElectricity: string = "Comparator oferte furnizare pentru energie electrică";
  public offerComparisonGas: string = "Comparator oferte furnizare pentru gaze naturale";

  @Input() title: string = "Autoritatea Nationala de Reglementare in Domeniul Energiei";
  @Output() rightSidebarEvent = new EventEmitter<boolean>();

  constructor(
    public navServices: NavService,
    private keycloakService: KeycloakService,
    protected userService: UserService,
    private router: Router,
    public documentService: DocumentService,
  ) {
    this.title = "Autoritatea Nationala de Reglementare in Domeniul Energiei";
  }

  collapseSidebar(): void {
    this.open = !this.open;
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar
  }

  rightSideBar(): void {
    this.rightSidebar = !this.rightSidebar
    this.rightSidebarEvent.emit(this.rightSidebar)
  }

  openMobileNav(): void {
    this.openNav = !this.openNav;
  }

  onPageChange(page: string): void {
    this.router.navigate(
      ['/'],
      {
        queryParams: {
          pagina: page,
        }
      }
    );
  }

  ngOnInit(): void { }

  login(): void {
    this.keycloakService.login({ redirectUri: environment.feUrl });
  }
}
